import * as React from 'react';
import { Button } from "@progress/kendo-react-buttons";
import styled from "styled-components";
import Popup from "../components/CusPopup";
import { Loader } from "@progress/kendo-react-indicators";

const ButtonToggle = styled(Button)`
color: blue;
opacity: 0.7;
background-color: transparent;
background-repeat: no-repeat;
border: none;
margin-top: -0.4em;
margin-left: -0.4em;
&:hover {
    background-color: transparent;
  }
${({ active }) =>
        active &&
        `opacity: 1; `}`;

const LoadingText = (props) => {

    return (
        <div style={{ textAlign: 'center' }}>
            <Popup
                className="popUpBox"
                trigger={props.show}
                setTrigger={props.setShow}>
                <div style={{ textAlign: "center", whiteSpace: "pre-line", fontWeight:'500'}}>
                    <p>{props.label}</p>
                </div>
                <div>
                    <Loader type="infinite-spinner" />
                </div>
               
            </Popup>
        </div>

    )
}


export default LoadingText;